import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { RxDB, getDatabase } from '../db/database';
import { documentRepository } from '../db/documentRepository';

// Интерфейс для значения контекста
interface DatabaseContextValue {
  db: RxDB | null;
  repository: typeof documentRepository;
  isInitialized: boolean;
}

// Создаем контекст с значением по умолчанию
const DatabaseContext = createContext<DatabaseContextValue>({
  db: null,
  repository: documentRepository,
  isInitialized: false
});

// Хук для использования контекста в компонентах
export const useDatabase = () => useContext(DatabaseContext);

interface DatabaseProviderProps {
  children: ReactNode;
}

// Провайдер контекста
export const DatabaseProvider = ({ children }: DatabaseProviderProps) => {
  
  const [db, setDb] = useState<RxDB | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);

  // Инициализация базы данных
  useEffect(() => {
    
    const initDatabase = async () => {
      try {
        const database = await getDatabase();
        
        setDb(database);
        
        await documentRepository.initialize();
        
        setIsInitialized(true);
      } catch (error) {
        setIsInitialized(false);
      }
    };

    initDatabase();

    // Очистка при размонтировании
    return () => {
      // RxDB автоматически очищает ресурсы
    };
  }, []);


  return (
    <DatabaseContext.Provider value={{ db, repository: documentRepository, isInitialized }}>
      {children}
    </DatabaseContext.Provider>
  );
}; 